import {useEffect, useState} from "react"
import {useParams} from "react-router-dom"
import {InputText} from "primereact/inputtext"
import {Dropdown} from "primereact/dropdown"
import {Button} from "primereact/button"
import commonStyles from "../../common.module.css"
import api from "../../../api"
import userContext from "../../../context/userContext"
import usePlaces from "../../../hook/usePlaces"
import useMachineTypes from "../../../hook/useMachineTypes"
import useMachines from "../../../hook/useMachines"
import backConfirmation from "../../../function/backConfirmation"
import confirmation from "../../../function/confirmation"
import FileList from "../../File/FileList"

export default function EnumMachineForm() {
  const {uuid} = useParams()
  const places = usePlaces()
  const machineTypes = useMachineTypes()
  const machines = useMachines().filter(machine => machine.uuid !== uuid)
  const back = () => window.history.back()

  const [name, setName] = useState("")
  const handleNameChange = (e) => setName(e.target.value)
  const [type, setType] = useState("")
  const handleTypeChange = (e) => setType(e.target.value)
  const [place, setPlace] = useState("")
  const handlePlaceChange = (e) => setPlace(e.target.value)
  const [parent, setParent] = useState("")
  const handleParentChange = (e) => setParent(e.target.value)

  const [files, setFiles] = useState([])
  const handleFilesChange = (changedFiles) => setFiles(changedFiles)

  const [refresher, setRefresher] = useState(false)
  const refresh = () => setRefresher(!refresher)

  const create = () => api
    .put("/machines", {name, type, place, parent, files})
    .then(back)
  const update = () => api
    .post(`/machines/${uuid}`, {uuid, name, type, place, parent})
    .then(back)
  const remove = () => api
    .delete(`/machines/${uuid}`)
    .then(back)
  const removeConfirmation = (e) => confirmation(e.currentTarget, "Opravdu smazat?", remove)
  const handleFormSubmit = (e) => {
    e.preventDefault()
    uuid ? update() : create()
  }

  useEffect(() => {
    if (uuid) {
      api.get(`/machines/${uuid}`)
        .then(({data}) => {
          setName(data.data.name)
          setType(data.data.type.uuid)
          setPlace(data.data.place.uuid)
          setParent(data.data.parent ? data.data.parent.uuid : "")
          setFiles(data.data.files || [])
        })
    }
  }, [uuid, refresher])

  return (
    <userContext.Consumer>
      {({hasPerm, isAdmin}) => (
        <>
          <form className={"col-12 md:col-6"} onSubmit={handleFormSubmit}>
            <div className={"p-fluid"}>
              <div className={"field"}>
                <label className={commonStyles.labelRequired}>Název:</label>
                <InputText required={true} value={name} onChange={handleNameChange}/>
              </div>

              <div className={"field"}>
                <label className={commonStyles.labelRequired}>Typ:</label>
                <Dropdown required={true} value={type} options={machineTypes} optionValue={"uuid"}
                          optionLabel={"name"} emptyMessage={"Žádné záznamy"}
                          onChange={handleTypeChange}/>
              </div>

              <div className={"field"}>
                <label className={commonStyles.labelRequired}>Místo:</label>
                <Dropdown required={true} value={place} options={places} optionValue={"uuid"}
                          optionLabel={"name"} emptyMessage={"Žádné záznamy"}
                          onChange={handlePlaceChange}/>
              </div>

              <div className={"field"}>
                <label>Nadřazený stroj:</label>
                <Dropdown value={parent} options={machines} optionValue={"uuid"}
                          optionLabel={"name"} emptyMessage={"Žádné záznamy"}
                          onChange={handleParentChange}/>
                <small className={commonStyles.fieldHelp}>Vyplňte pouze pokud je stroj součástí
                  jiného stroje.</small>
              </div>
            </div>

            <div className={"flex"}>
              <Button type={"button"} label={"Zpět"} className={"p-button-warning m-1"}
                      onClick={backConfirmation}/>
              <div className={"ml-auto"}>
                <Button type={"button"} label={"Smazat"} className={"p-button-danger m-1"}
                        onClick={removeConfirmation}
                        disabled={!uuid || !isAdmin()}/>
                <Button type={"submit"} label={"Uložit"} className={"m-1"}
                        disabled={!hasPerm("ROLE_PERM_ENUMS_WRITE")}/>
              </div>
            </div>
          </form>

          <div className={"col-12 md:col-6"}>
            <FileList files={files} onChange={uuid ? refresh : handleFilesChange}
                      entityUrl={uuid ? `/machines/${uuid}` : ""}
            isDisabled={!hasPerm("ROLE_PERM_ENUMS_WRITE")}/>
          </div>
        </>
      )}
    </userContext.Consumer>
  )
}
